import { render, staticRenderFns } from "./selectOrder.vue?vue&type=template&id=7139da21&"
import script from "./selectOrder.vue?vue&type=script&lang=js&"
export * from "./selectOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports